import React from "react";
import ChecklistNotAnsweredDeclineReasonRowCard from "./ChecklistNotAnsweredDeclineReasonRowCard";
import ChecklistNotAnsweredApproveOrDeclineRowCard from "./ChecklistNotAnsweredApproveOrDeclineRowCard";
import ChecklistNotAnsweredNoPermissionRowCard from "./ChecklistNotAnsweredNoPermissionRowCard";
interface Props {
  item: server.dto.DocumentChecklistItem
  canAnswer: boolean
  onAnswerSelected: (newState: server.dto.ChecklistItemStates, rejectionReason?: string) => void
  whoCanReviewApi: typeof window.CoreApi.Checklist.WhoCanReviewESignChecklistItem;
}

const ChecklistNotAnsweredRowCard = (props: Props) => {
  const [isDeclining, setIsDeclining] = React.useState(false);
  const { item } = props;

  const displayDeclineReason = () => { setIsDeclining(true); };
  const onFinishedDeclining = (reason: string) => { props.onAnswerSelected("declined", reason); };
  const onApproved = () => { props.onAnswerSelected("approved"); };

  if (props.canAnswer) {
    if (isDeclining) {
      return <ChecklistNotAnsweredDeclineReasonRowCard item={item} onDeclined={onFinishedDeclining} />;
    }

    return <ChecklistNotAnsweredApproveOrDeclineRowCard item={item} onApproved={onApproved} onDeclined={displayDeclineReason} />;
  }

  return <ChecklistNotAnsweredNoPermissionRowCard item={item} whoCanReviewApi={props.whoCanReviewApi} />;
};

export default ChecklistNotAnsweredRowCard;